const {
  APP: { INTERNAL_CONFIGURATIONS },
} = require('../../constants');

/**
 * Determines if internal configurations are enabled based on the provided configurations array.
 * Checks for specific feature flags like yellow button, ML integration and POTS integration.
 *
 * @param {Array<String>} internalConfigurations - Array of configuration flags to check
 * @returns {Object} Object containing enabled configuration flags:
 *   @returns {boolean} botonAmarilloEnabled - Whether yellow button is enabled
 *   @returns {boolean} inMlEnabled - Whether ML integration is enabled
 *   @returns {boolean} inPotsEnabled - Whether POTS integration is enabled
 *   @returns {boolean} enableMlTheme - Whether ML theme should be enabled (true if any of the above are enabled)
 * @example
 * const config = internalConfigurationsEnabled(['YELLOW_BUTTON', 'IN_ML']);
 * // Returns: {
 * //   botonAmarilloEnabled: true,
 * //   inMlEnabled: true,
 * //   inPotsEnabled: false,
 * //   enableMlTheme: true
 * // }
 */
const internalConfigurationsEnabled = (internalConfigurations = []) => {
  const configurations = internalConfigurations || [];

  const botonAmarilloEnabled = configurations.includes(INTERNAL_CONFIGURATIONS.YELLOW_BUTTON);
  const inMlEnabled = configurations.includes(INTERNAL_CONFIGURATIONS.IN_ML);
  const inPotsEnabled = configurations.includes(INTERNAL_CONFIGURATIONS.IN_POTS);
  const enableMlTheme = botonAmarilloEnabled || inMlEnabled || inPotsEnabled;

  return {
    botonAmarilloEnabled,
    inMlEnabled,
    inPotsEnabled,
    enableMlTheme,
  };
};

module.exports = internalConfigurationsEnabled;
